import {get as _get, find as _find, random as _random} from 'lodash';

import initialState from '../initialstate';

import {
	GET_GS_SCOPE_LINK_REQUEST,
	CHANGE_GS_TEAM,
	CHANGE_GS_SCOPE,
	POST_GS_SCOPE_LINK_REQUEST
} from '../../actions/actiontypes';

import {HttpStatusCodes} from '../../util/uiconstants';
import {GALinkStatus} from '../../util/uiconstants';

import normalizeScopesLinkRequest from './normalizeScopesLinkRequest';
import updateTeamsLinkRequest from './updateTeamsLinkRequest';
import updateScopesLinkRequest from './updateScopesLinkRequest';

export default function gsScopesLinkRequestReducer(state = initialState.gsScopesLinkRequest, action) {
	switch (action.type) {
		case GET_GS_SCOPE_LINK_REQUEST: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				let data = _get(action, 'response', []);
				data = data?.map((s) => {
					return {...s, teamList: s?.teamList?.filter((c) => c.gaLinkStatusId !== GALinkStatus.ComponentReferenceOnly)};
				});
				data = data?.filter((s) => s?.teamList?.length > 0);
				return normalizeScopesLinkRequest(data);
			}
			return state;
		}

		case CHANGE_GS_TEAM: {
			const teamId = _get(action, 'teamId', null);
			if (teamId) {
				return updateTeamsLinkRequest(state, teamId);
			}

			return state;
		}

		case CHANGE_GS_SCOPE: {
			const scopeId = _get(action, 'scopeId', null);
			const checked = _get(action, 'checked', null);

			if (scopeId) {
				const afterChange = updateScopesLinkRequest(state, scopeId, checked);
				return afterChange;
			}

			return state;
		}

		case POST_GS_SCOPE_LINK_REQUEST: {
			return state;
		}

		default:
			return state;
	}
}
